import * as React from "react";

interface IReportPdfReportProps {
    reportDataUri: string;
}

export const ReportPdfReport = (props: IReportPdfReportProps) => (
    <object style={{ margin: 0, padding: 0, width: 100 + "%", height: 100 + "%" }} type="application/pdf" data={props.reportDataUri + "#navpanes=0"} width="100%" height="100%"></object>
);
